export default "__VITE_ASSET__Cvtl86mg__"